import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class GlobalService {
  private _master_page_title: string = null;
  public _active_user = "";
  public _user_type: string = null;
  public _user_image = null;
  public _active_route = null;
  public _active_display_name = null;
  public _user_position = "";
  public version = "2.0.1";
  public counterId: number;

  // private _server_url = 'http://localhost:8000';
  // private _server_url = 'https://develop-server-aws.aavincoimbatore.com';
  //private _server_url = 'https://develop-server-aws.aavincoimbatore.com';

  private _server_url = "https://server-aws.aavincoimbatore.com";
  // private _server_url: string = 'http://192.168.1.39:8000';

  //private _server_url: string = 'http://192.168.1.25:8000';
  //private _server_url: string = 'http://192.168.1.4:8000';
  // private _server_url: string = 'http://192.168.1.36:8000';
  // private _server_url: string = 'http://192.168.1.14:8000';

  constructor(private snackBar: MatSnackBar, public router: Router) {}

  get server_url() {
    return this._server_url;
  }

  showSnakeBar(message: string) {
    this.snackBar.open(message, "", {
      duration: 2000,
    });
  }

  showWarningSnakeBar(message: string) {
    this.snackBar.open(message, "X", {
      duration: 1000,
      panelClass: ["blue-snackbar"],
    });
  }

  showErrorSnakeBar(message: string) {
    this.snackBar.open(message, "X", {
      duration: 1000,
      panelClass: ["red-snackbar"],
    });
  }

  navigateTo(component_path) {
    this.router.navigateByUrl(component_path);
  }

  set set_master_page_title(page_title) {
    this._master_page_title = page_title;
  }

  get get_master_page_title() {
    return this._master_page_title;
  }

  set set_active_user(page_title) {
    this._active_user = page_title;
  }

  set set_active_user_type(page_title) {
    this._user_type = page_title;
  }

  set set_active_user_position(user_position) {
    this._user_position = user_position;
  }

  // Getter for user type
  get get_user_type() {
    return this._user_type;
  }

  set set_active_image(image) {
    this._user_image = image;
  }

  set set_active_url(url) {
    this._active_route = url;
  }

  set set_active_url_display_name(display_name) {
    this._active_display_name = display_name;
  }

  set set_counter_id(counter_id) {
    this.counterId = counter_id;
  }

  get get_counter_id() {
    return this.counterId;
  }
}
